var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"process-node-main-box"},[_c('ul',{staticClass:"process-node-item-box"},_vm._l((_vm.nodeArr),function(item,index){return _c('li',{key:index},[_c('i'),_c('span',{style:(index === 0 ? 'color: #0d4b87' : '')},[_vm._v(_vm._s(item.nodeWay))]),_c('span',[_vm._v("【"+_vm._s(item.type ? item.type == "1" ? "司机" : item.type == "2" ? "客服" : item.type == "3" ? "调度" : item.type == "4" ? "库管" : item.type == "5" ? "门卫" : "" : "暂无")+"】 "+_vm._s(item.nodeName))]),_c('span',[_vm._v(_vm._s(item.nodeDate))]),(_vm.isBack)?_c('span',{class:[
          item.status == '2' ||
          item.status == '4' ||
          item.status == '9' ||
          item.status == '12' ||
          item.status == '14'
            ? 'isShowBtn'
            : 'isHiddenBtn',
        ],on:{"click":function($event){return _vm.handleBack(item)}}},[_vm._v("回退")]):_c('span'),(item.remark)?_c('span',{class:[item.remark ? 'isShowBtn' : 'isHiddenBtn']},[_vm._v(_vm._s(item.remark))]):_c('span')])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }